import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "./periodEvents.module.less";
import {PeriodEventsTable} from "./EventsTable/EventsTable.tsx";
import {HeaderItem, TableHeaderAction} from "@src/Pages/Views/tableTypes.ts";
import {Gt} from "@src/i18n/Gt.tsx";
import cn from "classnames";
import {
    PeriodEventsList
} from "@src/Pages/Views/Manager/AttendanceHistory/PeriodEvents/PeriodEventsList/PeriodEventsList.tsx";
import {WorkPeriodInfo} from "@src/CommonComponents/WorkPeriodInfo/WorkPeriodInfo.tsx";
import {DataNotFoundMessage, WorkingTime} from "@src/Pages/Views/Common.tsx";
import {EmployeeWithWorkdays} from "@src/Store/employeesStore.ts";
import React from "react";


const eventsTableHeaderItems: Array<HeaderItem> = [
    {
        label: <Gt>Employee name</Gt>,
        dataLabel: "name",
        paramKey: 'employee.name',
        paramKeys: ['last_name', 'first_name'],
        type: TableHeaderAction.sorting
    },
    {
        label: <Gt>Total working hours</Gt>,
        dataLabel: "worked_time",
        paramKey: 'workdays',
        type: TableHeaderAction.sorting,
        renderer: (workdays) => <WorkingTime workdays={workdays}/>,
    }
]

export const PeriodEvents = ({employees}: { employees?: EmployeeWithWorkdays[] }) => {
    if (!employees) return null
    return (
        <>
            <div className={styles.eventsGroups}>
                {employees?.map(employee =>
                    <Stack direction={"column"} className={cn(styles.whiteBoard, styles.eventsBoard)}
                           key={employee?.id}>
                        <PeriodEventsList employee={employee}/>
                        <WorkPeriodInfo
                            workDays={employee?.workdays}
                            className={cn(styles.workdayInfo)}
                        />
                    </Stack>
                )}
            </div>
            {employees?.length === 0 &&
                <DataNotFoundMessage text={<Gt>We couldn’t find users</Gt>}/>
            }
            <PeriodEventsTable headerColumns={eventsTableHeaderItems} employees={employees}/>
        </>
    )
}